export default __webpack_public_path__ + "static/media/undo_hidden.b15a057e.svg";